interface UserSymbolProps {
  picture?: string;
  size?: number;
}

const UserSymbol = ({ picture, size = 25 }: UserSymbolProps) => {
  if (picture) {
    return <div className={`symbol symbol-${size}px symbol-circle`}>
      <div className="symbol-label" style={{backgroundImage:`url(${picture})`}}></div>
    </div>
  }else{
    return <i className="fa-solid fa-user fs-2"></i>
  }
}

export default UserSymbol